const formatAddress = data => {
  const address = data.reduce((acc, item, i, arr) => {
    const skipTypes = [
      'postal_code',
      'country',
      'administrative_area_level_1',
      'administrative_area_level_2',
      'postal_code_suffix',
    ]

    if (item.types && !item.types.some(type => skipTypes.includes(type))) {
      acc += `${item.short_name}`

      const isOnlyRoute = item.types.length === 1 && item.types[0] === 'route'
      const isNotLast = i < arr.length - 1

      if (isOnlyRoute && isNotLast) {
        acc += ','
      }

      acc += ' '
    }

    return acc
  }, '')

  return address.trim()
}

export { formatAddress }
